import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui';

/** Copies `value`, and says on the button whether it worked. */
export function CopyButton({ value, label }: { value: string; label: string }) {
  const [state, setState] = useState<'copied' | 'failed'>();

  useEffect(() => {
    if (state === undefined) {
      return;
    }
    const timer = setTimeout(() => setState(undefined), 1500);
    return () => clearTimeout(timer);
  }, [state]);

  const copy = (): void => {
    // Absent outside a secure context — the console opened over a LAN address — where the
    // value can still be selected by hand.
    if (navigator.clipboard === undefined) {
      setState('failed');
      return;
    }
    navigator.clipboard.writeText(value).then(
      () => setState('copied'),
      () => setState('failed'),
    );
  };

  return (
    <Button onClick={copy} aria-label={`Copy ${label}`} title={state === 'failed' ? 'Copying is not allowed here; select the value instead' : `Copy ${label}`}>
      {state === 'copied' ? <Check className="size-3.5 text-positive" /> : <Copy className="size-3.5" />}
      <span className="max-sm:sr-only">{state === 'copied' ? 'Copied' : state === 'failed' ? 'Select it' : 'Copy'}</span>
    </Button>
  );
}
